var map = {
	"./icn-banks-g.svg": 657,
	"./icn-banks-old.svg": 1845,
	"./icn-banks.svg": 257,
	"./icn-bf-o.svg": 670,
	"./icn-bf-w.svg": 663,
	"./icn-bf-y.svg": 193,
	"./icn-bf.svg": 187,
	"./icn-consumers-g.svg": 658,
	"./icn-consumers-old.svg": 1846,
	"./icn-consumers.svg": 158,
	"./icn-engagement-shield.svg": 338,
	"./icn-engagement.svg": 1847,
	"./icn-oil-green-active.svg": 1848,
	"./icn-oil-green-inactive.svg": 1849,
	"./icn-oil-orange-active.svg": 1850,
	"./icn-oil-orange-inactive.svg": 1851,
	"./icn-oil-red-active.svg": 1852,
	"./icn-oil-red-inactive.svg": 1853,
	"./icn-oil-redorange-active.svg": 1854,
	"./icn-oil-redorange-inactive.svg": 1855,
	"./icn-oil-yellow-active.svg": 1856,
	"./icn-oil-yellow-inactive.svg": 1857,
	"./icn-po-o.svg": 666,
	"./icn-po-w.svg": 659,
	"./icn-po-y.svg": 189,
	"./icn-po.svg": 183,
	"./icn-pp-o.svg": 667,
	"./icn-pp-w.svg": 660,
	"./icn-pp-y.svg": 190,
	"./icn-pp.svg": 184,
	"./icn-producers-g.svg": 656,
	"./icn-producers-old.svg": 1858,
	"./icn-producers.svg": 157,
	"./icn-rb-o.svg": 668,
	"./icn-rb-w.svg": 661,
	"./icn-rb-y.svg": 191,
	"./icn-rb.svg": 185,
	"./icn-socially-responsible.svg": 1859,
	"./icn-sy-o.svg": 671,
	"./icn-sy-w.svg": 664,
	"./icn-sy-y.svg": 194,
	"./icn-sy.svg": 188,
	"./icn-tb-o.svg": 669,
	"./icn-tb-w.svg": 662,
	"./icn-tb-y.svg": 192,
	"./icn-tb.svg": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1844;